import {
  ReportingApi,
  SecurityApi
} from 'bff/client';

export type ApiClient = {
  securityApi: SecurityApi;
  reportingApi: ReportingApi;
};
